<div class="main container" *ngIf="orderOn == true">
    <div class="page-header">
        <h1>{{LOCALIZATION.exportsDownloads}}</h1>
    </div>
    <div class="col-md-3">
        <div class="panel panel-default">
            <div class="panel-body">
                <span class="lead"> {{LOCALIZATION.downloadFilter}} </span>
                <hr>
                <form>
                    <div class="bottom-spacing">
                        <label for="downloadDate">{{LOCALIZATION.download}} {{LOCALIZATION.date}}</label>
                        <div>
							<input type="text" 
							       class="form-control flatpickr" 
							       id="downloadDate" name="downloadDate"
							       [(ngModel)]="filters.dateRange"
							       placeholder="{{LOCALIZATION.downloadDatePlaceholder}}" 
							       (focus)="openDatePicker('downloadDate')"/>
							<i class="fas fa-calendar-alt pointMe" style="float:right;margin-top:4px;" title="{{LOCALIZATION.openCalendar}}"
							   (click)="openDatePicker('downloadDate')"></i>                               
                        </div>
                    </div>
                    <div class="bottom-spacing">
                        <label for="downloadStatus">{{LOCALIZATION.download}} {{LOCALIZATION.status}}</label>
						<select class="form-control" name="downloadStatus" id="downloadStatus" [(ngModel)]="filters.status">
							<option value=""></option>
							<option value="COMPLETED">{{LOCALIZATION.orderStatusCompleted}}</option>
							<option value="EXPIRED">{{LOCALIZATION.orderStatusExpired}}</option>
							<option value="FAILED">{{LOCALIZATION.orderStatusFailed}}</option>
							<option value="IN_PROGRESS">{{LOCALIZATION.orderStatusInProgress}}</option>
							<option value="TIMEOUT">{{LOCALIZATION.orderStatusTimedOut}}</option>
						</select>                        
                    </div>
                    <div>
                       <div class="primary-controls">
                           <button class="btn btn-default delete" (click)="clear()">
                           		<span aria-hidden="true"></span> {{LOCALIZATION.clear}} 
                           </button>
                           <button class="btn btn-primary submit-button submit-button-sm" (click)="filter()">
                           		<span class="fas fa-filter" aria-hidden="true"></span> {{LOCALIZATION.filter}} 
                           </button>
                       </div>                        
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="col-md-9">
        <div *ngIf="orders.length > 0">
		<div class="row">
		  <div class="col-md-12" style="margin:10px 0">
		    <div class="flex-container" style="display: flex; flex-wrap: wrap; align-items: center; gap: 2px;">
		      <div style="margin-right: 1px; display: inline-table; height: 34px;">
		        <div style="display: table-cell; vertical-align: middle;">
		        <label class="control control--checkbox">
		          <input aria-label="Select all" type="checkbox" name="allOrders" [(ngModel)]="selectedOrders.all" (click)="toggleAllOrders()"/>
		          <div class="control__indicator"></div>
		        </label>
		        </div>
		      </div>
		      
		      <div class="btn-group hidden-xs" style="margin-right: 2px;" ngbDropdown #pageDropdownRef="ngbDropdown">
		        <button id="pagesizeButton" type="button" class="btn btn-primary btn-sm submit-button submit-button-sm" ngbDropdownToggle>
		          <span class="hidden-xs">{{LOCALIZATION.showing}}</span> <span class="badge">{{pagination.elementsPerPage}}</span> per page <span class="caret"></span>
		        </button>
		        <ul class="dropdown-menu custom-drop" ngbDropdownMenu role="menu" aria-labelledby="pagesizeButton">
		          <li role="menuitem" (click)="pageSizeChanged(10); closeDropdown(pageDropdownRef);"><a>10</a></li>
		          <li class="divider"></li>
		          <li role="menuitem" (click)="pageSizeChanged(20); closeDropdown(pageDropdownRef);"><a>20</a></li>
		          <li class="divider"></li>
		          <li role="menuitem" (click)="pageSizeChanged(30); closeDropdown(pageDropdownRef);"><a>30</a></li>
		          <li class="divider"></li>
		          <li role="menuitem" (click)="pageSizeChanged(50); closeDropdown(pageDropdownRef);"><a>50</a></li>
		        </ul>
		      </div> 
		      
		      <div class="btn-group" style="margin-right: 2px;" ngbDropdown #menuDropdownRef="ngbDropdown">
		        <button id="sortButton" type="button" class="btn btn-primary btn-sm submit-button submit-button-sm" ngbDropdownToggle>
		          {{LOCALIZATION.sortBy}} {{pagination.sorting.description}} <span class="caret"></span>
		        </button>
		        <ul class="dropdown-menu custom-drop" ngbDropdownMenu role="menu" aria-labelledby="sortButton">
		          <li role="menuitem" (click)="sortingChanged({sort:'created,desc',description:'Date - Newest'}); closeDropdown(menuDropdownRef);"><a>{{LOCALIZATION.date}} - {{LOCALIZATION.newest}}</a></li>
		          <li class="divider"></li>
		          <li role="menuitem" (click)="sortingChanged({sort:'created,asc',description: 'Date - Oldest'}); closeDropdown(menuDropdownRef);"><a>{{LOCALIZATION.date}} - {{LOCALIZATION.oldest}}</a></li>
		          <li class="divider"></li>
		          <li role="menuitem" (click)="sortingChanged({sort:'requestName,asc',description: 'Name - A-Z'}); closeDropdown(menuDropdownRef);"><a>{{LOCALIZATION.name}} - {{LOCALIZATION.sortByAToZ}}</a></li>
		          <li class="divider"></li>
		          <li role="menuitem" (click)="sortingChanged({sort:'requestName,desc',description:'Name - Z-A'}); closeDropdown(menuDropdownRef);"><a>{{LOCALIZATION.name}} - {{LOCALIZATION.sortByZToA}}</a></li>
		          <li class="divider"></li>
		          <li role="menuitem" (click)="sortingChanged({sort:'orderStatus,desc',description:'Status - Highest'}); closeDropdown(menuDropdownRef);"><a>{{LOCALIZATION.status}} - {{LOCALIZATION.highest}}</a></li>
		          <li class="divider"></li>
		          <li role="menuitem" (click)="sortingChanged({sort:'orderStatus,asc',description:'Status - Lowest'}); closeDropdown(menuDropdownRef);"><a>{{LOCALIZATION.status}} - {{LOCALIZATION.lowest}}</a></li>
		        </ul>
		      </div>
		      
		      <div class="pull-right primary-controls" style="display: flex; gap: 2px; margin-left: auto;">
		        <button class="btn btn-primary btn-circle" 
		          (click)="loadDownloads()" title="{{LOCALIZATION.refresh}}">
		          <i class="fas fa-sync"></i>
		        </button>
		        <button *ngIf="orders && selectedOrders.selected.length > 0 && userPermissions['ROLE_ORDER_MANAGEMENT']" 
		          class="btn btn-circle btn-danger" title="Delete orders" 
		          (click)="onDeleteOrders()">
		          <i class="fas fa-trash" aria-hidden="true"></i>
		        </button>
		      </div>
		    </div>
		  </div>
		</div>
            <div id="currentPage">
                <div class="panel z-depth-1 transactionPanel" *ngFor="let order of orders">
                    <div class="panel-heading">
                        <div class="row">
                            <div class="col-xs-6 col-sm-6 col-md-3">
                            	<label>{{LOCALIZATION.name}}</label>
								<label class="control control--checkbox">
                              	<input name="orderSelect" [(ngModel)]="order.selected" (change)="toggleOrder(order.id)" type="checkbox"/>
                              	<div class="control__indicator"></div>
                              	<p style="font-size:13px;"> {{order.requestName}}</p>
                            	</label>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-3">
                                <label>{{LOCALIZATION.created}}</label>
                                <p>{{order.createdStr}}</p>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-3">
                                <label>{{LOCALIZATION.status}}</label>
                                <p><span>{{order.orderStatusPretty}}</span></p>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-3" *ngIf="order.orderStatus && order.orderStatus == 'COMPLETED' || order.orderStatus == 'EXPIRED' || order.orderStatus == 'FAILED'">
                                <label>{{LOCALIZATION.action}}</label>
                                <p *ngIf="order.orderStatus == 'COMPLETED'">
                                	<a type="button" class="btn btn-primary btn-xs" (click)="downloadOrder()" href="{{order.downloadStr}}">{{LOCALIZATION.download}}</a>
                                </p>
                                <p *ngIf="order.orderStatus == 'EXPIRED' || order.orderStatus == 'FAILED'">
                                	<a type="button" class="btn btn-danger btn-xs delete" (click)="deleteOrder(order.id)">{{LOCALIZATION.deleteItem}}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		    <div class="tab-pagination-container">
				<div class="text-center">
					  <ngb-pagination class="pagination custom-page pagination-sm"
					    [(page)]="pagination.page" 
					    [pageSize]="pagination.elementsPerPage"
					    [collectionSize]="pagination.totalElements" 
					    (pageChange)="pagination.pageChanged($event)"
					    [maxSize]="5"
					    [boundaryLinks]="true"
					    previousText="&#xf053;"
					    nextText="&#xf054;"
					    firstText="&#xf053;&#xf053;"
					    lastText="&#xf054;&#xf054;">
					  </ngb-pagination>					
				</div>
            </div>
        </div>
        <div *ngIf="orders.length < 1">
	        <div>    
	            <i>{{LOCALIZATION.resultsEmpty}}</i>
	        </div>        
	        <div class="top-spacing bottom-spacing text-right primary-controls">
	            <button class="btn btn-primary btn-circle" (click)="loadDownloads()" title="{{LOCALIZATION.refresh}}"><i class="fas fa-sync"></i></button>
	        </div>
        </div>
    </div>
</div>
<div class="main container" *ngIf="orderOn == false">
    <div class="text-center full-center">
        <h1><span style="font-size:3em" class="fas fa-times-circle text-red"></span></h1>
        <h3><span>{{LOCALIZATION.loginPolite}}</span></h3>
    </div>
</div>
